function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-6036.819,1.716l-2.829-2.828a.5.5,0,0,1-.146-.352.5.5,0,0,1,.146-.355l2.829-2.828a.5.5,0,0,1,.353-.146.5.5,0,0,1,.354.146.5.5,0,0,1,0,.706l-1.977,1.977h17.588a.5.5,0,0,1,.5.5.5.5,0,0,1-.5.5h-17.584l1.973,1.974a.5.5,0,0,1,0,.706.5.5,0,0,1-.354.147A.5.5,0,0,1-6036.819,1.716Z",
  transform: "translate(14.793 6040.001) rotate(90)"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-6023.888,1.717a.5.5,0,0,1,0-.706l1.975-1.975H-6039.5a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h17.585l-1.974-1.975a.5.5,0,0,1,0-.706.5.5,0,0,1,.706,0l2.829,2.829a.5.5,0,0,1,.146.352.5.5,0,0,1-.146.355l-2.829,2.827a.494.494,0,0,1-.353.147A.491.491,0,0,1-6023.888,1.717Z",
  transform: "translate(1.864 6040) rotate(90)"
});

var SvgSort = function SvgSort(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 19.586,
      height: 20.001,
      viewBox: "0 0 19.586 20.001",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSort, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Sort.f8ae88a9.svg";
export { ForwardRef as ReactComponent };